import React, { useState } from "react";
import styled from "styled-components";
import { grid } from "styled-components-grid";
// import { Button } from "../common";
import { Link } from "../link";
import { ButterflyIcon } from "../butterfly-icon";
import { RouteComponentProps, navigate, useLocation } from "@reach/router";
import { trackCustomEvent } from "gatsby-plugin-google-analytics";
import { useInView } from "react-intersection-observer";

const FooterContainer = styled.footer`
  width: 100%;
  position: relative;
  margin: 0 auto;
  padding-bottom: 70px;
  @media (min-width: ${(props) => props.theme.breakpoints.sm}px) {
    padding-bottom: 0px;
  }
  .top {
    text-align: center;
    background: ${(props) => props.theme.colors.white};
    p {
      padding-bottom: 15px;
      margin-bottom: 0px;
    }
  }
  .search {
    background: ${(props) => props.theme.colors.delta};
    color: ${(props) => props.theme.colors.white};
    padding: 0.5rem;
    input {
      display: block;
      position: relative;
      background-color: #dddddd;
      box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1);
      border: none;
      resize: none;
      font: inherit;
      font-weight: normal;
      color: #000;
      width: 100%;
      max-width: 20rem;
      padding: 0.5rem;
      margin: 0.5rem auto;
      padding-right: 35px;
      background-size: 40px 20px;
      background-position: right center;
      background-repeat: no-repeat;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http:%2F%2Fwww.w3.org%2F2000%2Fsvg' width='512' height='512' viewBox='0 0 30.239 30.239'%3E%3Cpath d='M20.194 3.46c-4.613-4.613-12.12-4.613-16.734 0-4.612 4.614-4.612 12.12 0 16.735 4.108 4.107 10.506 4.547 15.116 1.34.097.46.32.897.676 1.254l6.718 6.717c.98.977 2.56.977 3.535 0 .978-.978.978-2.56 0-3.535l-6.718-6.72c-.355-.354-.794-.577-1.253-.674 3.21-4.61 2.77-11.008-1.34-15.118zm-2.12 14.614c-3.445 3.444-9.05 3.444-12.493 0-3.44-3.444-3.44-9.048 0-12.492 3.444-3.443 9.05-3.443 12.493 0 3.444 3.444 3.444 9.048 0 12.492z' fill='%23777'%2F%3E%3C%2Fsvg%3E");
    }
  }
  .content {
    .country {
      padding: 15px 25px 0px 25px;
      font-weight: 400;
      text-align: center;
      font-size: 16px;
      @media (min-width: ${(props) => props.theme.breakpoints.sm}px) {
        padding: 25px;
        font-size: 19px;
      }
      color: white;
    }
    background: ${(props) => props.theme.colors.mortar};
    color: white;
    .mail {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: center;
      a {
        max-width: fit-content;
        display: block;
        text-decoration: none;
        background: white;
        cursor: pointer;
        font-weight: 300;
        color: black;
        margin: 0 auto;
        padding: 10px;
      }
      text-align: center;
      max-width: 1000px;
      margin: 25px auto;
      ${grid({})}
      color: #bbb;
      div {
        ${grid.unit({ size: { md: 1 / 1, lg: 1 / 3 } })}
        padding: 10px;
        @media (min-width: ${(props) => props.theme.breakpoints.sm}px) {
          padding: 10px 25px;
        }
      }
      @media (min-width: ${(props) => props.theme.breakpoints.sm}px) {
        padding-bottom: 0px;
      }
    }
    .copyright {
      a {
        flex: 1;
        display: inline;
          text-decoration: underline;
          background-image: linear-gradient(
            to right,
            ${(props) => props.theme.colors.tangerine} 0,
            ${(props) => props.theme.colors.tangerine} 100%
            );
            background-position: 0px 20px;
            background-size: 0 100%;
            background-repeat: no-repeat;
            transition: background 0.5s;
          cursor: pointer;
          font-weight: 300;
          &:hover,
          &:focus {
            background-image: linear-gradient(to right, white 0, white 100%);
            background-size: 100% 100%;
          }
      }
      background: black;
      color: white;
      padding: 20px 15px;
      text-align: center;
      p {
        max-width: unset;
      }
    }
  }
`;

const Feeter: React.FC<RouteComponentProps> = () => {
  const [query, setQuery] = useState("");
  const handleSubmit = (evt) => {
    evt.preventDefault();
    trackCustomEvent({
      category: "Search",
      action: "Submit",
      label: query,
    });
    navigate(`/search?search=${query}`);
  };

  const [ref, inView] = useInView({
    rootMargin: "0px 0px",
    triggerOnce: false,
  });

  const handleInputChange = (evt) => {
    setQuery(evt.target.value);
  };
  const searchPage = useLocation().pathname === "/search" ? "none" : "block";

  return (
    <FooterContainer ref={ref}>
      <div className="top">
        {inView ? <ButterflyIcon animate={true} width="4em" /> : <div style={{ height: '4em' }} />}
        <p className="center">Transform the way the world sees you</p>
      </div>
      <form
        className="search"
        action="/search"
        onSubmit={handleSubmit}
        style={{ display: searchPage }}
      >
        <input
          aria-label="search"
          name="search"
          value={query}
          onChange={handleInputChange}
        />
      </form>
      <div className="content">
        <div className="country">
          <div>
            <p className="regular center">
              Baku | Brisbane | Luxembourg | Melbourne | New Delhi | Prague |
              Tel Aviv | White River | Lisbon
            </p>
          </div>
        </div>
        <div className="mail">
          <div>
            <p className="center" style={{ lineHeight: "1.5em" }}>
              Curious, ready and wanting to talk{" "}
            </p>
            <Link to="mailto:referrals@katanya.co.uk?subject=Referral inquiry">
              {" "}
              Book a call
            </Link>
          </div>
          <div>
            <p className="center" style={{ lineHeight: "1.5em" }}>
              Tech-geek, design-chic and digital dreamers{" "}
            </p>
            <Link to="mailto:careers@katanya.co.uk?subject=Careers inquiry">
              {" "}
              Join our team
            </Link>
          </div>
          <div>
            <p className="center" style={{ lineHeight: "1.5em" }}>
              Speaking gigs, quotes and commentary{" "}
            </p>
            <Link to="mailto:media@katanya.co.uk?subject=Media inquiry">
              {" "}
              Contact us
            </Link>
          </div>
        </div>
        <div className="copyright">
          <div>
            <p className="center" style={{ lineHeight: "1.3em" }}>
              Copyright © 2011-{new Date().getFullYear()} Katanya LLP (UK). All
              rights reserved.
            </p>
            <p className="center" style={{ lineHeight: "1.3em" }}>
              For compagny information visit our{" "}
              <Link to="/about">About Us</Link> page. We’re using{" "}
              <Link to="/cookies">Cookies</Link> and here’s our{" "}
              <Link to="/privacy">Privacy Policy.</Link>
            </p>
          </div>
        </div>
      </div>
    </FooterContainer>
  );
};

const Footer = React.memo(Feeter);

export { Footer };
